export default "__VITE_ASSET__0792121f__"